import { InjectionToken } from '@angular/core';

export interface MaintenanceConfig {
  isMaintenance: boolean;
  message: string;
}

export const MAINTENANCE_CONFIG =
  new InjectionToken<MaintenanceConfig>(
    'MAINTENANCE_CONFIG'
  );
